import { Link } from 'react-router-dom';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block border border-foreground-300 text-foreground-500 text-xs px-4 py-1.5 rounded-full mb-5 tracking-wide">
          gtbuy sheet ecosystem
        </span>

        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-900 font-light leading-tight">
          Why Smart Buyers Use
          <br />
          <span className="font-semibold">Spreadsheet Engines</span>
          <br />
          <span className="text-foreground-600">Instead of Reviews</span>
        </h2>

        <p className="mt-5 text-foreground-500 text-sm md:text-base leading-relaxed max-w-xl mx-auto">
          Reviews are subjective. Spreadsheets are structured. Data beats opinions. The GTBuy sheet engine aggregates real-time product pricing from{' '}
          <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 underline hover:text-primary-700">
            kaspreadsheet.com
          </a>
          {' '}&mdash; giving you instant, objective comparison across multiple platforms like Kakobuy and Superbuy. No more switching between 10 browser tabs.
        </p>

        <Link
          to="/article-gtbuy-sheet"
          className="mt-7 inline-flex items-center gap-2 bg-foreground-900 text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          Read Full SEO Article
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}